export default {
  namespaced: true,
  state: {
    items: []
  },
  getters: {
    items (state) {
      return state.items
    },
    istDokumentHochgeladen: (state) => (filename) => {
     const items = state.items.filter(i => i.filename === filename)
      if (items.length > 0) {
        return (items[0].result === 1)
      } else {
        return false
      }
    }
  },
  mutations: {
    items (state, items) {
      state.items = items
    },
    itemNachreichen (state, item) {
      const index = state.items.findIndex(i => i.filename === item.filename)
      if (index !== -1) {
        state.items[index] = item
      }
    },

    item (state, item) {
      const index = state.items.findIndex(i => i.name === item.name)
      if (index !== -1) {
        state.items[index] = item
      }
    },

    addItem(state, item) {
      state.items.push(item)
    },
    removeItem(state, name) {
      const index = state.items.findIndex(i => i.name === name)
      console.log(index)
      state.items.splice(index, 1)
    },

    reset (state, name) {
      const index = state.items.findIndex(i => i.name === name)
      if (index !== -1) {
        state.items[index].result = null
        state.items[index].file = null
        state.items[index].loading = false
        state.items[index].pdf = false
        state.items[index].cancelToken = null
      }
    },

    resetNachreichen (state, filename) {
      const index = state.items.findIndex(i => i.filename === filename)
      if (index !== -1) {
        state.items[index].result = null
        state.items[index].file = null
        state.items[index].loading = false
        state.items[index].pdf = false
        state.items[index].cancelToken = null
      }
    },
    result (state, nameResult) {
      const index = state.items.findIndex(i => i.name === nameResult.name)
      if (index !== -1) {
        state.items[index].result = 4
        state.items[index].loading = false
      }
    },
    resetItems(state) {
      state.items = []
    },

  },

  actions: {
    checkFile ({ commit, state }, nameFile) {
      const index = state.items.findIndex(i => i.name === nameFile.name)
      const that = this
      if (index !== -1) {
        const listitem = state.items[index]
        listitem.loading = true
        listitem.file = nameFile.file
        listitem.pdf = nameFile.pdf
        commit('item', listitem)
        return new Promise(resolve => {
          const type = nameFile.file.name.split('.').pop()
          if (!nameFile.pdf && !['jpeg', 'jpg', 'png'].includes(type.toLocaleLowerCase())) {
            resolve(5)
          } else if (nameFile.pdf && !['pdf'].includes(type.toLocaleLowerCase())) {
            resolve(6)
          } else if(nameFile.name.includes("Dokument Nachreichung") && nameFile.file.size > 10485760) {
            //10 MB = 10485760
            resolve(7)
          } else if (nameFile.file.size > 15728640) { // 15728640 = 15MB
            resolve(4)
          } else if (nameFile.pdf) {
            let formData = new FormData()
            formData.append('files', nameFile.file)
            const tokenSource = that._vm.$http.CancelToken.source()
            listitem.cancelToken = tokenSource
            commit('item', listitem)
            return that._vm.$http.post('api/file', formData,
                {
                  cancelToken: tokenSource.token,
                  headers: {
                    'Content-Type': 'multipart/form-data;charset=utf-8'
                  }
                }).then(result => {
              resolve(result)
            }).catch(() => {
              // IGNORE
            })
          } else {
            const image = new Image()
            const objectURL = URL.createObjectURL(nameFile.file)
            image.onload = function () {
              const max = Math.max(image.width, image.height)
              const min = Math.min(image.width, image.height)
              URL.revokeObjectURL(objectURL)
              if (max < 1024 || min < 768) {
                resolve(3)
              } else {
                let formData = new FormData()
                formData.append('files', nameFile.file)
                const tokenSource = that._vm.$http.CancelToken.source()
                listitem.cancelToken = tokenSource
                commit('item', listitem)
                return that._vm.$http.post('api/file', formData,
                    {
                      cancelToken: tokenSource.token,
                      headers: {
                        'Content-Type': 'multipart/form-data;charset=utf-8'
                      }
                    }).then(result => {
                  resolve(result)
                }).catch(() => {
                  // IGNORE
                })
                /* setTimeout(() => {
                  resolve(Math.floor(Math.random() * 3))
                }, (5 + Math.floor(Math.random() * 3)) * 1000) */
              }
            }
            image.onerror = function () {
              resolve(6)
            }
            image.src = objectURL
          }
        }).then(result => {
          if (result.data !== undefined) {
            const res = result.data.process_info.result
            if (res === 'Allowed') {
              listitem.result = 1
            } else if (res === 'Blocked') {
              listitem.result = 0
            } else {
              listitem.result = 2
            }
          } else {
            listitem.result = result
          }
          commit('item', listitem)
        }).finally(() => {
          listitem.loading = false
          commit('item', listitem)
        })
      }
    }
  }
}
